var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16.0 17.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91977207,0.422310502 C7.48254044,-0.140770167 8.45246446,-0.140770167 9.04648086,0.422310502 L15.552223,6.95617527 C16.1490506,7.51863133 16.1490506,8.48730566 15.5534722,9.0500745 L9.04773103,15.5526917 C8.48464941,16.1476445 7.51503817,16.1476445 6.95195702,15.5526917 L0.446215342,9.0500745 C-0.148738447,8.48824305 -0.148738447,7.51800625 0.446215342,6.95617527 Z M7.9724738,1.50035129 L1.52019379,8.00296849 L7.99968763,14.4805871 L14.4786184,8.00256512 L8.01349862,1.50932275 C7.99743428,1.50334177 7.9854728,1.50035129 7.9724738,1.50035129 Z M7.99968763,9.97156471 C8.55276981,9.97156471 8.99960952,10.4196546 8.99960952,10.9714866 C8.99960952,11.5233186 8.55151964,11.9714085 7.99968763,11.9714085 C7.44785563,11.9714085 6.99976575,11.5233186 6.99976575,10.9714866 C6.99976575,10.4196546 7.44785563,9.97156471 7.99968763,9.97156471 Z M7.99968763,3.97203339 C8.41371779,3.97203339 8.74962905,4.30794465 8.74962905,4.7219748 L8.74962905,8.22170141 C8.74962905,8.63573156 8.41371779,8.97164282 7.99968763,8.97164282 C7.58565748,8.97164282 7.24974622,8.63573156 7.24974622,8.22170141 L7.24974622,4.7219748 C7.24974622,4.33450526 7.58565748,3.97203339 7.99968763,3.97203339 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.547473508864641e-13 0.24970719218254178)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,5.55111512e-17 16,5.55111512e-17 16,15.9989063 0,15.9989063 0,5.55111512e-17",
    stroke: "none",
    fill: "#F7981B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdated);
export default __webpack_public_path__ + "static/media/outdated.639b6d8f489b185c7c347c1f3e8d9fb2.svg";
export { ForwardRef as ReactComponent };